import { useEffect, useState } from 'react'
import { DebounceInput } from 'react-debounce-input'
import { useIntl } from 'react-intl'

import ProductList from '../component/List'
import Export from '../component/List/Export'
import FilterDrawer from '../component/List/FilterDrawer'

import { BreadCrumb } from 'src/_metronic/layout/components'
import { useGetList } from '../context/useQuery'
import { useProduct } from '../hook'
import Import from '../component/List/Import'

function Dashboard() {
  const intl = useIntl()
  const { listFilter, listFilterSet } = useProduct()
  const { isLoading } = useGetList()
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('0')
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (listFilter.filterList.length > 0) {
      const searchFilter = listFilter.filterList.find((x) => x.key === 'nm')

      if (searchFilter) {
        setSearch(searchFilter.value[0])
        // setBadges([{ key: 'search', value: searchFilter.value[0] }])
      }
    }
  }, [])

  return (
    <>
      <BreadCrumb currentPage={intl.formatMessage({ id: 'PRODUCT_PLURAL' })} />
      <div>
        <h3 className='text-dark fw-bolder mt-10 mb-2'>
          {intl.formatMessage({ id: 'PRODUCT_PLURAL.LIST' })}
        </h3>
        <p className='text-muted fs-6'>{intl.formatMessage({ id: 'PRODUCT_PLURAL.LIST.DESC' })}</p>
      </div>
      <div className='d-flex flex-column flex-root' id='kt_app_root'>
        <div className='card mt-10'>
          <div className='card-header border-0 pt-6'>
            <div className='card-title'>
              <div className='d-flex align-items-center position-relative my-1'>
                <i className='ki-outline ki-magnifier fs-3 position-absolute ms-5'></i>
                <DebounceInput
                  debounceTimeout={500}
                  type='text'
                  className='form-control form-control-solid w-500px ps-13'
                  placeholder={intl.formatMessage({ id: 'GLOBAL.FILTER.SEARCH.PRODUCT' })}
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value)
                    listFilterSet({
                      ...listFilter,
                      paging: {
                        ...listFilter.paging,
                        currentPageNumber: 1,
                      },
                      filterList: [
                        {
                          key: 'nm',
                          operator: 14,
                          logicalOp: 2,
                          value: [e.target.value],
                          childFilters: [
                            {
                              key: 'SkuID',
                              operator: 14,
                              logicalOp: 2,
                              value: [e.target.value],
                              childFilters: [],
                            },
                            {
                              key: 'brcd',
                              operator: 14,
                              logicalOp: 2,
                              value: [e.target.value],
                              childFilters: [],
                            },
                          ],
                        },
                        // {
                        //   key: 'stts',
                        //   value: [status],
                        //   operator: 1,
                        //   logicalOp: 2,
                        // },
                        ...(status !== '0'
                          ? [{ key: 'stts', value: [status], operator: 1, logicalOp: 2 }]
                          : []),
                      ],
                    })
                  }}
                />
              </div>
            </div>
            <div className='card-toolbar'>
              <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
                <div className='d-flex align-items-center gap-2 gap-lg-3'>
                  <a type='button' className='btn btn-light' href='products/new-product'>
                    <i className='bi bi-plus-circle-fill fs-2 me-2'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                    {intl.formatMessage({ id: 'PRODUCT.ADD' })}
                  </a>
                  <button
                    className='btn btn-light'
                    onClick={() => setOpen(!open)}
                  >
                    <i className='bi bi-sliders fs-4 me-4'></i>
                    {intl.formatMessage({ id: 'GLOBAL.FILTER' })}
                  </button>
                  <FilterDrawer
                    open={open}
                    setOpen={setOpen}
                    filter={listFilter.filterList}
                    search={search}
                    status={status}
                    setStatus={setStatus}
                    setSearch={setSearch}
                    setFilter={(value: any) => {
                      listFilterSet({
                        ...listFilter,
                        filterList: value,
                        paging: {
                          ...listFilter.paging,
                          currentPageNumber: 1,
                        },
                      })
                    }}
                  />

                  <Export tableName='products' />
                  <div>
                    <Import tableName='products' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='card-body pt-10'>
            <ProductList loading={isLoading} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard
